import { defineComponent } from "vue";

export default defineComponent({
  template: `<div>
    <div class="">
      <div class="timer mb-3">
        <div>
          <!-- <div class="day">
            <span class="number">{{ days }}</span>
            <div class="format">dní</div>
          </div> -->
          <div class="hour">
            <span class="number">{{ hours }}</span>
            <div class="format">hodin</div>
          </div>
          <div class="min">
            <span class="number">{{ minutes }}</span>
            <div class="format">minut</div>
          </div>
          <div class="sec">
            <span class="number">{{ seconds }}</span>
            <div class="format">sekund</div>
          </div>
        </div>
        <div v-if="isExpired">
          <p class="timer-expired">Čas vypršel!</p>
        </div>
      </div>
    </div>
    </div>`,
  name: "GiftCountdown",
  props: ["endTimestamp"],
  data() {
    return {
      isExpired: null,
      end: null,
      interval: null,
      days: 0,
      minutes: 0,
      hours: 0,
      seconds: 0,
    };
  },
  mounted() {
    this.end = this.endTimestamp ? new Date(parseInt(this.endTimestamp)).getTime() : new Date().getTime();

    this.timerCount(this.end);

    this.interval = setInterval(() => {
      this.timerCount(this.end);
    }, 1000);
  },
  methods: {
    timerCount: function (end: number) {
      const now = new Date().getTime();
      const passTime = end - now;

      if (passTime < 0) {
        this.isExpired = true;
        clearInterval(this.interval);
      } else {
        this.calcTime(passTime);
      }
    },
    calcTime: function (dist: number) {
      this.days = Math.floor(dist / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((dist % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((dist % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((dist % (1000 * 60)) / 1000);
    },
  },
});
